import { Sender } from 'xstate';
import asyncCallback from '../../../framework/logic/utils/asyncCallback';
import models from '../../../model';

export type LoginModalActionsCallback = Sender<{
  type:
    | 'LOGIN_MODAL_STATE_VISIBLE'
    | 'LOGIN_MODAL_STATE_AWAIT_LOGIN'
    | 'LOGIN_MODAL_STATE_CLOSED';
  data:
    | object
    | {
        payload: {
          state: string;
        };
      };
}>;

export const watchLoginModalActions = () =>
  asyncCallback(async (callback: LoginModalActionsCallback) => {
    const watcherOptions = {
      callback,
    };

    return await models.loginWatcher(watcherOptions);
  });
